import {
    UmbLinkedAccountDelete,
    UmbLinkedAccountSearch
} from "@/shared/api/bankService";
import { FetchState } from "@/shared/types";
import {
    UmbLinkedAccount,
    AdminUmbLinkedAccountSearchRequest,
    UmbDeleteLinkedAccountState
} from "../types";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";


const defaultState: UmbDeleteLinkedAccountState = {
    firstName: "",
    lastName: "",
    hsaAccountNumber: "",
    emailAddress: "",
    fetchState: FetchState.Uninitialized,
    linkedAccounts: []
};

export const useUmbAdminDeleteLinkedAccountStore = defineStore("umbAdminDeleteLinkedAccount", {
    state: (): UmbDeleteLinkedAccountState => (_.cloneDeep(defaultState)),
    getters: {
        canSearch: state => state.fetchState !== FetchState.Loading,
        hasFirstName: state => !!state.firstName && state.firstName.length > 0,
    },
    actions: {
        setFirstName (firstName: string) {
            this.firstName = firstName;
        },
        setLastName (lastName: string) {
            this.lastName = lastName;
        },
        setHsaAccountNumber (hsaAccountNumber: string) {
            this.hsaAccountNumber = hsaAccountNumber;
        },
        setEmailAddress (emailAddress: string) {
            this.emailAddress = emailAddress;
        },
        setFetchState (newFetchState: FetchState) {
            this.fetchState = newFetchState;
        },
        setLinkedAccounts (newLinkedAccounts: UmbLinkedAccount[]) {
            this.linkedAccounts = newLinkedAccounts;
        },
        setDeleteDisabled (ula: UmbLinkedAccount) {
            const linkedAccountFound = this.linkedAccounts.indexOf(ula);
            if (linkedAccountFound === -1) {
                return;
            }

            ula.isDeleted = true;
            ula.isDeletedAtBank = true;
            this.linkedAccounts = [ ...this.linkedAccounts ];
        },
        delete (ula: UmbLinkedAccount) {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            this.setFetchState(FetchState.Loading);
            return UmbLinkedAccountDelete(ula.linkedBankAccountId, this.hsaAccountNumber)
                .then(response => {
                    this.setDeleteDisabled(ula);
                })
                .catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                })
                .finally(() => this.setFetchState(FetchState.Loaded));
        },
        search (request: AdminUmbLinkedAccountSearchRequest) {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            this.setFirstName("");
            this.setLastName("");
            this.setHsaAccountNumber("");
            this.setEmailAddress("");
            this.setFetchState(FetchState.Loading);
            return UmbLinkedAccountSearch(request)
                .then(response => {
                    const data = response.data;
                    this.setFirstName(data.firstName);
                    this.setLastName(data.lastName);
                    this.setHsaAccountNumber(data.hsaAccountNumber);
                    this.setEmailAddress(data.emailAddress);
                    this.setLinkedAccounts(data.linkedAccounts);
                })
                .catch(err => {
                    storeHelper.handleError({ error: err, rethrow: true });
                })
                .finally(() => this.setFetchState(FetchState.Loaded));
        }
    }
});